export const SectionSkeletonComponent = {
  bindings: {
    nbItems: '<?',
  },
  templateUrl: 'components/Skeletons/section-skeleton/section-skeleton.html',
};
